import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_auth/admin/auth/providers/$id/edit")({
  parseParams(params) {
    return z.object({ id: z.coerce.number() }).parse(params);
  },
});
